var map = {
	"./LogoLight.svg": "95be",
	"./bankless.png": "ee72",
	"./boba-network.png": "edd0",
	"./chainsafe.svg": "6a06",
	"./connext.svg": "95f4",
	"./element.png": "28fb",
	"./eth-foundation.svg": "169f",
	"./ethswarm.svg": "bc94",
	"./galaxis.svg": "e4cc",
	"./golem-foundation.png": "0f93",
	"./ledger.svg": "a927",
	"./livepeer.svg": "37c3",
	"./moralis.svg": "131a",
	"./nodereal.svg": "b5eb",
	"./openq.png": "630d",
	"./pwn.svg": "f964",
	"./rekt.png": "d2f6",
	"./serotonin.jpg": "d903",
	"./serotonin.png": "727a",
	"./starkware.svg": "1be4",
	"./uniswap.svg": "3e51",
	"./wallet-connect.svg": "6300",
	"./windingtree.png": "9f96",
	"./wintermute.svg": "5ac6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8ed6";